import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUserName } from 'utils';
import { navigationRootChannelsSelector, navigationSelector } from 'common/selectors';
import { CtPrivacyRepository } from 'common/api/models';
import { ChannelList, HelpMenuFragment, LanguageChangeMenu, MobileMenuUserProfile, SubMenuFragment } from './fragments';

const mapStateToProps = (state) => ({
  rootChannels: navigationRootChannelsSelector(state),
  navigationChannels: navigationSelector(state),
  username: getUserName(),
});

export const SUB_MENU_TYPES = {
  LANGUAGES: 'LANGUAGES',
  HELP: 'HELP',
};

export const MobileMenu = withRouter(
  connect(
    mapStateToProps,
    {}
  )(
    class extends React.Component {
      state = {
        currentChannelId: null,
        showSubMenu: false,
        subMenuType: null,
      };

      changeCurrentChannelId = (newId) => {
        const currentChannelId = this.state.currentChannelId;
        this.setState({ currentChannelId: newId }, () => {
          const elementToFocus =
            // try to focus the previous channel (in case we are going back)
            document.querySelector(`[data-e2e="mobile-nav-item-wrapper-${currentChannelId}"]`) ||
            // try to focus the new channel (in case we are going forward)
            document.querySelector(`[data-e2e="mobile-nav-item-${newId}"]`) ||
            // try to focus the back button as default (usually this shouldn't happen)
            document.querySelector('[data-e2e="mobile-menu-back-button"]');

          elementToFocus?.focus();
        });
        if (newId === -1) {
          this.setState({
            currentChannelId: null,
            showSubMenu: false,
          });
        } else {
          this.setState({
            currentChannelId: newId,
            showSubMenu: false,
          });
        }
      };

      resetCurrentChannelId = (url) => {
        this.setState({
          currentChannelId: null,
          showSubMenu: false,
        });
        window.scrollTo(0, 0);
        this.goToUrl(url);
      };

      showHideSubMenu = (type) => {
        const showHide = !this.state.showSubMenu;
        this.setState({
          currentChannelId: null,
          showSubMenu: showHide,
          subMenuType: type,
        });
        window.scrollTo(0, 0);
      };

      goToUrl = (url) => {
        setTimeout(() => this.props.history.push(url + '#top'), 0);
        this.props.showHideMobileMenu();
      };

      render() {
        return (
          <div
            id="ct-navigation-mobile"
            className={`ct-mobile-menu ${this.props.className ? this.props.className : ''}`}
            data-e2e="mobile-menu-container"
          >
            {!this.state.showSubMenu && (
              <Fragment>
                <ChannelList
                  channelId={this.state.currentChannelId}
                  navigationChannels={this.props.navigationChannels}
                  rootChannels={this.props.rootChannels}
                  changeId={this.changeCurrentChannelId}
                  resetId={this.resetCurrentChannelId}
                  goToChannel={this.goToUrl}
                />
                {!this.state.currentChannelId && (
                  <Fragment>
                    {!CtPrivacyRepository.isPublic() && (
                      <MobileMenuUserProfile username={this.props.username} goToUrl={this.goToUrl} />
                    )}
                    <SubMenuFragment showHideSubMenu={this.showHideSubMenu} />
                  </Fragment>
                )}
              </Fragment>
            )}
            {this.state.showSubMenu && this.state.subMenuType === SUB_MENU_TYPES.LANGUAGES && (
              <LanguageChangeMenu
                showHideSubMenu={this.showHideSubMenu}
                showHideMobileMenu={this.props.showHideMobileMenu}
              />
            )}

            {this.state.showSubMenu && this.state.subMenuType === SUB_MENU_TYPES.HELP && (
              <HelpMenuFragment
                showHideSubMenu={this.showHideSubMenu}
                showHideMobileMenu={this.props.showHideMobileMenu}
              />
            )}
          </div>
        );
      }
    }
  )
);
